<template>
  <nav
    id="mobile-menu"
    class="mobile-menu fixed z-40 right-0 top-0 pt-48 h-dvh w-dvw overflow-y-auto max-h-dvh flex-col justify-start bg-peach-200 px-2 sm:px-10"
    aria-label="Mobile Menu"
  >
    <ul class="flex flex-col items-center max-w-80 sm:max-w-96 ml-auto w-full pb-4">
      <MobileMenuItem
        v-for="(item, index) in menuData"
        :key="index"
        :item="item"
        :level="1"
        @close="closeMenu"
      />
    </ul>
  </nav>
</template>

<script setup lang="ts">
import MobileMenuItem from './MobileMenuItem.vue'

interface MenuItem {
  title: string
  url: string
  target: string
  children?: MenuItem[]
}

defineProps<{
  menuData: MenuItem[]
}>()

const closeMenu = () => {
  document.body.classList.remove('no-scroll', 'menu-open')
  const menu = document.getElementById('mobile-menu')
  if (menu) {
    menu.classList.remove('menu-open')
  }
  window.dispatchEvent(new CustomEvent('menu-close'))
}
</script>

<style scoped></style>
